import {getSingleInputByNameV3} from "../../../helpers/forms/formInputsHelpers";
import Axios from "axios";
import {loading, stopLoading} from "../../../helpers/loading";
import {displayLocalValidationError} from "../../../helpers/forms/validationErrors/utils";

class TotalPreviewComponent {

    /** @var {HTMLInputElement} */
    discountCodeInput;

    /** @var {boolean} */
    withTOSWarning;

    /** @var {number|null} */
    debounceTimeout = null;

    /** @var {Array} */
    pendingPromises = [];

    discountCodeChangeCallbacks = [];

    /**
     * @param {HTMLElement} container
     * @param {GlobalState} state
     */
    constructor(container, state) {
        this.container = container
        this.state = state;

        this.withTOSWarning = false;

        this.getTotalsPreviewHtmlRoute = getSingleInputByNameV3(document.body, 'get_totals_preview_html_route');
    }

    async updateTotalsFromServer() {
        return new Promise((resolve, reject) => {
            // Clear existing timeout
            if (this.debounceTimeout) {
                clearTimeout(this.debounceTimeout);
            }

            // Add this promise to the pending list
            this.pendingPromises.push({resolve, reject});

            // Set new timeout
            // noinspection JSValidateTypes
            this.debounceTimeout = setTimeout(async () => {
                try {
                    // Execute the actual update logic
                    await this._executeUpdateTotalsFromServer();

                    // Resolve all pending promises
                    this.pendingPromises.forEach(({resolve}) => resolve());
                    this.pendingPromises = [];
                } catch (error) {
                    // Reject all pending promises
                    this.pendingPromises.forEach(({reject}) => reject(error));
                    this.pendingPromises = [];
                }

                this.debounceTimeout = null;
            }, 150);
        });
    }

    async _executeUpdateTotalsFromServer() {
        // Get new total HTML
        try {
            const orderData = this.state.getOrderDataForServer();

            if (this.withTOSWarning) {
                orderData.withTOSWarning = true;
            }

            const result = await Axios.post(
                this.getTotalsPreviewHtmlRoute,
                orderData
            );

            // Append to container
            this.container.innerHTML = result.data.body;

            // Initialize components
            this.initializeComponents();
        } catch (error) {
            if (error.response && error.response.data && error.response.data.errors) {
                const validationErrors = error.response.data.errors

                // If a wrong discount was passed
                if (validationErrors.invalid_discount_code) {
                    // Clear discount from state
                    this.state.setDiscountCode('');

                    // Then get a fresh order summary from the server
                    this.updateTotalsFromServer().then();

                    // And show error to user
                    displayLocalValidationError(
                        document.body,
                        'DUMMY',
                        validationErrors.invalid_discount_code
                    )
                }

                // If a discount no longer applies
                if (validationErrors.discount_constraints_not_met) {
                    // Clear discount from state
                    this.state.setDiscountCode('');

                    // Then get a fresh order summary from the server
                    this.updateTotalsFromServer().then();

                    // TODO:    Show better message to user 'no longer applies' vs 'does not apply' for
                    //          first time coupon use
                    // And show error to user
                    displayLocalValidationError(
                        document.body,
                        'DUMMY',
                        'Discount does not apply to this order'
                    )
                }

                // If a discount is superseded by system discount
                if (validationErrors.system_discount_is_better_than_code_discount) {
                    // Clear discount from state
                    this.state.setDiscountCode('');

                    // Then get a fresh order summary from the server
                    this.updateTotalsFromServer().then();

                    // TODO:    Show better message to user 'no longer applies' vs 'does not apply' for
                    //          first time coupon use
                    // And show error to user
                    displayLocalValidationError(
                        document.body,
                        'DUMMY',
                        'A better discount has been applied automatically to your order'
                    )
                }
            }
        }
    }

    /**
     * Initializes fresh HTML after it has been retrieved from the server
     */
    initializeComponents() {
        this.getDiscountRoute = getSingleInputByNameV3(this.container, 'get_discount_route');
        this.eventId = getSingleInputByNameV3(this.container, 'event_id');

        // Init discount code input
        this.discountCodeInput = this.container.querySelector('input[name="discount_code"]');

        this.discountCodeInput.addEventListener('keyup', e => {
            if (e.key === 'Enter') {
                this.handleDiscountCodeUseRequest();
            }
        })

        // Setup event handlers
        this.container.querySelector('.use-discount-code-button')
            .addEventListener('click', () => {
                this.handleDiscountCodeUseRequest()
            })
    }

    handleDiscountCodeUseRequest() {
        const discountCode = this.discountCodeInput.value.trim();

        if (discountCode) {
            loading();
            this.state.setDiscountCode(discountCode)

            // Refresh totals
            this.updateTotalsFromServer()
                .then(() => {
                    stopLoading();
                    // Notify callbacks
                    this.discountCodeChangeCallbacks.forEach(callback => {
                        callback();
                    })
                })

        } else {
            // Clear discount
            this.state.setDiscountCode('');
            // Refresh totals
            this.updateTotalsFromServer().then(() => {
                // Notify callbacks
                this.discountCodeChangeCallbacks.forEach(callback => {
                    callback();
                })
            });
        }
    }

    addDiscountCodeChangeListener(callback) {
        this.discountCodeChangeCallbacks.push(callback);
    }

    getOrderTotal() {
        const totalFromServer = parseFloat(getSingleInputByNameV3(this.container, 'order_total'));

        if (isNaN(totalFromServer)) {
            return 0;
        }

        return totalFromServer
    }
}

export {TotalPreviewComponent}
